module.exports = __webpack_public_path__ + "img/icon_map_sdsh.970d4463.png";